export interface Props {
    containerProps?: any;
    videoProps: any;
    rounded?: boolean;
}

export enum VideoType {
    Iframe = 'iframe',
    Video = 'video',
}